<script>
// import { required } from "vuelidate/lib/validators";
import {
  esellerMethods,
  esellerComputed,
  layoutMethods,
  erpUserRolesMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
import ImageUpload from "@/components/ImageUpload";
import { getModuleAccess } from "@/router/helper.js";

/**
 * ESupplies Manage Banners
 */
export default {
  page: {
    title: "Manage eSupplies Banner",
  },
  data() {
    return {
      action: "",
      isInvalid: false,
      file: null,
      bannerId: 0,
      folder: "esupplies-banners",
      bannerImage: {
        filename: null,
        type: null,
        base64: null,
      },
      bannerItem: {
        bannerId: null,
        bannerName: "",
        bannerActiveNow: 0,
        bannerType: 'brand',
        bannerDestinationId: null,
        bannerDescription: "",
        bannerPreviewImage: ""
      },
      formExitChecker: {
        bannerId: null,
        bannerName: "",
        bannerActiveNow: 0,
        bannerType: 'brand',
        bannerDestinationId: null,
        bannerDescription: "",
        bannerPreviewImage: ""
      },
      esuppliesBannerModule: {
        access: {
          create: true,
          update: true,
          delete: true
        }
      }
    };
  },
  components: {
    ImageUpload,
    Multiselect
  },
  validations: {},
  computed: {
    ...esellerComputed,
    selectedAdElement: {
      get(){
        var selected = null;
        this.targetOptions.forEach(brand => {
          if(brand.value == this.bannerItem.bannerDestinationId){
            selected = brand;
          }
        });
        return selected;
      },
      set(obj){
        if(obj){
          this.bannerItem.bannerDestinationId = obj.value;
        }else {
          this.bannerItem.bannerDestinationId = null;
        }
        
      }
    },
    targetOptions: {
      get(){
        if(this.bannerItem.bannerType == "brand"){
          return this.SellerBrandOptions;
        } else {
          return this.SellerProductOptions;
        }
      }
    },
    SellerBrandOptions: {
      get(){
        return this.brands.map(brand => {
          return { 'text': brand.brandName, 'value': brand.brandId }
        });
      }
    },
    SellerProductOptions: {
      get(){
        return this.products.map(product => {
          return { 'text': product.productName, 'value': product.productId }
        });
      }
    }
  },
  watch: {
    'bannerItem.bannerActiveNow': function(newVal) {
      this.bannerItem.bannerActiveNow = newVal | 0;
      console.log(newVal);
    }
  },
  mounted: async function () {
    // fetch active brands only
    this.listSellerBrands({ 
      rows: 99999, 
      field: 'status',
      keyword: '1',
      sort: 'brandName',
      orderDesc: false
    });
    this.listSellerProducts({ 
      rows: 99999,
      sort: 'productName',
      orderDesc: false
    });
    this.action = this.$route.params.action;
    this.bannerId = this.$route.params.id;
    this.changeTitle({
      title: (this.action == "add" ? "Add" : "Edit") + " E-Seller Banner",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "E-Seller", to: { name: "ESeller" } },
        { text: "Banner", to: { name: "ESeller Banner" } },
        {
          text: `${this.action == "add" ? "Add" : this.bannerId}`,
          to: { name: "" },
        },
      ],
    });
    if (this.action == "edit") {
      await this.getBannerById();
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eSupplies', 'Banners')
      .then((access) => this.esuppliesBannerModule.access = access);

  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...erpUserRolesMethods,
    async getBannerById() {
      let params = {
        rows: 12,
        page: 1,
        search: this.bannerId,
        searchField: "id",
        sort: "name",
        orderDesc: true,
        bannerType: {
          text: "All",
          value: null
        },
        bannerStatus: {
          text: "All",
          value: null
        }
      };
      await this.listSellerBanners(params).then(() => {
        this.bannerItem = {
          bannerId: this.banners[0].bannerId,
          bannerName: this.banners[0].bannerName,
          bannerActiveNow: this.banners[0].bannerActiveNow,
          bannerType: this.banners[0].destinations.type,
          bannerDestinationId: this.banners[0].destinations.id,
          bannerDescription: this.banners[0].bannerDescription,
          bannerPreviewImage: this.banners[0].bannerImageSrc != '' ? 
            this.banners[0].bannerImageSrc : require('@/assets/images/img-placeholder.png'),
          oldBannerName: this.banners[0].bannerName
        }

        this.formExitChecker = {
          bannerId: this.banners[0].bannerId,
          bannerName: this.banners[0].bannerName,
          bannerActiveNow: this.banners[0].bannerActiveNow,
          bannerType: this.banners[0].destinations.type,
          bannerDestinationId: this.banners[0].destinations.id,
          bannerDescription: this.banners[0].bannerDescription,
          bannerPreviewImage: this.banners[0].bannerImageSrc != '' ? 
            this.banners[0].bannerImageSrc : require('@/assets/images/img-placeholder.png'),
          oldBannerName: this.banners[0].bannerName
        }
      });
    },
    initBrandProductSelections() {
     this.bannerItem.bannerDestinationId  = null;
    },
    createBanner(){
      var bannerObj = { ...this.bannerItem };
      console.log(bannerObj);
      // Validation
      if(!bannerObj.bannerDestinationId){
          this.isInvalid = true;
          return;
      }
      console.log(bannerObj);
      delete bannerObj.bannerId;
        
      if(this.bannerImage.base64){
        var bannerImage = { ...this.bannerImage };
        bannerImage.folder = this.folder;

        this.uploadLogo(bannerImage)
        .then((imageKey) => {
            bannerObj = { 
            ...bannerObj,
            bannerImageSrc: imageKey
            }
            
            this.create(bannerObj);
        })
        .catch((err) => {
            Swal.fire("Upload Failed!",`${err}`, "error");
        });
      } else {
          this.create(bannerObj);
      }
    },
    saveBanner(){
    var bannerObj = { ...this.bannerItem };

    if(this.bannerImage.base64){
        var bannerImage = { ...this.bannerImage };
        bannerImage.folder = this.folder;

        this.uploadLogo(bannerImage)
        .then((imageKey) => {
            bannerObj = { 
            ...bannerObj,
            bannerImageSrc: imageKey
            }
            
            this.update(bannerObj);
        })
        .catch((err) => {
            Swal.fire("Upload Failed!",`${err}`, "error");
        });
    } else {
      this.update(bannerObj);
    }
    },
    create(banner){
      this.createSellerBanner(banner)
      .then(() => {
        this.createModal = false;
        Swal.fire(
          "Create Successful!", 
          `${banner.bannerName} has been created.`, 
          "success")
          .then(() => {
            this.clearLogo();
            this.$router.back();
          });
        // this.populateBanners();
      })
      .catch((error) => {
        let message = error == 'duplicate name' ? "The banner name is already taken!" : `${banner.bannerName} was not created.`;
        Swal.fire("Create Failed!", message, "error");
        this.clearLogo();
      });
    },
    update(banner){
      let oldBannerName = banner.oldBannerName.length < 1 ? `${banner.bannerId} (no name)` : banner.oldBannerName;
      this.updateSellerBanner(banner)
        .then(() => {
        Swal.fire(
          "Update Successful!", 
          `${oldBannerName} has been updated.`,
          "success")
          .then(() => {
            this.clearLogo();
            this.$router.back();
          });
        })
        .catch((error) => {
        let message = error == 'duplicate name' ? "The banner name is already taken!" : `${oldBannerName} was not updated.`;
        Swal.fire("Update Failed!", message, "error");
        this.clearLogo();
        });
    },
    clearLogo(){
      this.bannerImage = {
        filename: null,
        type: null,
        base64: null
      }
    },
    clearBanner() {
      this.bannerItem = {
          bannerId: null,
          bannerName: "",
          bannerActiveNow: 0,
          bannerType: 'brand',
          bannerDestinationId: null,
          bannerDescription: ""
      }
      this.formExitChecker = {
          bannerId: null,
          bannerName: "",
          bannerActiveNow: 0,
          bannerType: 'brand',
          bannerDestinationId: null,
          bannerDescription: ""
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-3">&nbsp;</div>
    <div class="card col-md-6">
      <div class="card-body">
        <div class="row">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form class="px-4 py-3" @submit.prevent="handleSubmit(action == 'add' ? createBanner : saveBanner)" @@reset.prevent="reset">
            <div class="row">
                <label v-if="action == 'add' && !esuppliesBannerModule.access.create"
                  class="form-label medium fw-bold text-danger mb-3"
                  >Note: Your access is limited. You cannot create a Banner.</label
                >
                <label v-if="action == 'edit' && !esuppliesBannerModule.access.update"
                  class="form-label medium fw-bold text-danger mb-3"
                  >Note: Your access is limited. You cannot update a Banner.</label
                >
                <div class="col-md-12 mb-3">
                <label class="form-label small fw-bold"
                    >Banner Name<span style="color: red">*</span></label
                >
                <validation-provider name="Banner name" rules="required" v-slot="validationContext">
                    <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Enter Banner Name"
                    v-model="bannerItem.bannerName"
                    :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                </validation-provider>
                </div>
                <div class="cold-md-12 mb-3">
                <label
                    for="formFile"
                    class="form-label small fw-bold"
                    >Banner Description</label
                >
                <b-form-textarea
                    id="textarea"
                    placeholder="Enter Banner description..."
                    rows="3"
                    max-rows="6"
                    v-model="bannerItem.bannerDescription"
                ></b-form-textarea>
                </div>
                <div class="cold-md-12 mb-3">
                <label class="form-label small fw-bold">Banner Type</label>
                <div class="form-check">
                    <input class="form-check-input" value="brand"  type="radio" :reset-on-options-change='true' v-model="bannerItem.bannerType"  v-on:change="initBrandProductSelections" name="flexRadioDefault" id="flexRadioDefault1"  checked="checked">
                    <label class="form-check-label" for="flexRadioDefault1">
                    Brand
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" value="product" v-model="bannerItem.bannerType"  v-on:change="initBrandProductSelections"  type="radio" name="flexRadioDefault" id="flexRadioDefault2">
                    <label class="form-check-label" for="flexRadioDefault2">
                        Product
                    </label>
                </div>
                </div>
                <div class="col-md-12 mb-3">
                <div :class="{ 'invalid': isInvalid }">
                    <label class="typo__label form-label small fw-bold">{{bannerItem.bannerType == 'brand' ? 'Brands' : 'Products'}}<span style="color: red">*</span>
                    </label>
                    <validation-provider name="target" rules="required" v-slot="{ errors, ariaMsg }">
                    <multiselect 
                        v-model="selectedAdElement" 
                        :options="targetOptions"
                        track-by="value"
                        label="text"
                        name="target"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        :placeholder="bannerItem.bannerType == 'brand' ? 'Select Brand Category' : 'Select Product Item'"
                        :allow-empty="true"
                        :preselect-first="false"
                        :class="{
                        'invalid': errors[0]
                        }"
                    ></multiselect>
                    <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                    </b-form-invalid-feedback>
                    </validation-provider>
                </div>

                
                </div>
                <div class="cold-md-12 mb-3">
                <image-upload 
                  v-if="action == 'add' ? true : bannerItem.bannerPreviewImage != ''"
                  v-model="bannerImage" 
                  :imageSrc="bannerItem.bannerPreviewImage" 
                  label="Banner Image" 
                  :isRequired="true" />
                </div>
                <div class="cold-md-12 mb-3">
                <div class="form-check form-switch">
                    <input class="form-check-input" v-model="bannerItem.bannerActiveNow" type="checkbox" id="flexSwitchCheckDefault">
                    <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                </div>
                </div>
            </div>
            <div class="text-end mt-3">             
                <b-button
                  variant="light"
                  class="w-sm"
                  @click="$router.back()"
                  >Close</b-button
                >
                <b-button
                  :disabled="action == 'add' ? !esuppliesBannerModule.access.create : !esuppliesBannerModule.access.update"
                  variant="primary"
                  class="w-sm ms-2"
                  type="submit"
                  >Save</b-button
                >
            </div>
            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
    display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background:#f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092!important;
  border-color: #e73092!important;
  margin-bottom: 0!important;
  font-weight: 400!important;
}

.multiselect__tag-icon:after {
    color: #fff !important;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background-color: #e73092!important;
}
</style>